import React from 'react';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';

import { colors } from '@/globalStyles';
import { RECTANGLE, ELLIPSE } from '@/constants';
import { GridContainer, Label } from '@/components/SideBar/styles';

import RectangleIcon from '@/icons/shapes-and-vectors/rectangle.svg';
import EllipseIcon from '@/icons/shapes-and-vectors/ellipse.svg';

import { ShapeCardStyled } from './styles';

const data = [
  {
    id: uuidv4(),
    name: RECTANGLE,
    icon: RectangleIcon,
  },
  {
    id: uuidv4(),
    name: ELLIPSE,
    icon: EllipseIcon,
  },
];

const ShapesAndVectors = props => {
  const { selectedSection, handleShapeSelection, handleDragStart } = props;
  const selectedShapeName = selectedSection?.shape?.name;

  const intl = useIntl();

  return (
    <GridContainer gridTemplateColumns="repeat(2, 1fr)" gridTemplateRows="130px">
      {data.map(item => (
        <Box key={item.id} sx={{ display: 'grid', gridTemplateRows: 'max-content 1fr', gridGap: '10px' }}>
          <Label>
            {intl.formatMessage({ id: `cmme.shape.${item.name.toUpperCase()}`, defaultMessage: item.name })}
          </Label>
          <ShapeCardStyled
            border={`1px solid ${item.name === selectedShapeName ? colors.primary : colors.transparent}`}
            onClick={handleShapeSelection.bind(null, item.name)}
            onDragStart={handleDragStart.bind(null, item.name)}
          >
            <img draggable onDragStart={handleDragStart.bind(null, item.name)} src={item.icon} alt="" />
          </ShapeCardStyled>
        </Box>
      ))}
    </GridContainer>
  );
};

export default ShapesAndVectors;
